import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import TextControl from '../../container/customizedInputs/TextControl';
import { errorClassification } from '../../errorHandler';

import categoriasServices from '../../services/categoriasServices';

const CategoriaForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [categoria, setCategoria] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    if(id){
      fetchCategoria(id)
    } else {
      nuevaCategoria()
    }
  }, [id]);

  useEffect(() => {

    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol !== 'Admin')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchCategoria = async (id) => {
    try {
      const data = await categoriasServices.obtenerCategoriaPorId(id);
      setCategoria(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const nuevaCategoria = async () => {
    try {
      setCategoria({titulo: '', codigo: '', abreviacion: ''});
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const guardarCategoria = async () => {
    try {
      let data;
      if(esNuevo){
        data = await categoriasServices.crearCategoria({categoria: categoria});
      } else {
        data = await categoriasServices.actualizarCategoria(categoria.id, {categoria: categoria});
      }

      setCategoria(data);

      handleShowModal("Datos actualizados")
      if(esNuevo){
        navigate(`/categoria/${data.id}/edit`);
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCategoria({...categoria,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    guardarCategoria()
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <TextControl
                className='mb-3'
                value={categoria.titulo}
                name={'titulo'}
                handleInput={handleInput}
              />

              <TextControl
                className='mb-3'
                value={categoria.codigo}
                name={'codigo'}
                handleInput={handleInput}
              />

              <TextControl
                className='mb-3'
                value={categoria.abreviacion}
                name={'abreviacion'}
                handleInput={handleInput}
              />
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Guardar</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>

            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default CategoriaForm;